<div [formGroup]="groupForm" class="flex flex-column w-28rem h-full surface-ground border-md px-4 py-3 radius-md">
    <div class="flex justify-content-between px-2 py-3">
        <p class="h5 font-bold">{{ title | translate }}</p>
    </div>

    <div class="flex gap-16 flex-column justify-content-between pt-4 flex-1">
        <div class="flex flex-column gap-3 px-3">
            <span class="w-full p-float-label p-input-icon-right">
                <input
                    class="w-full"
                    id="groupName"
                    pInputText
                    formControlName="groupName"
                    placeholder="{{ 'default-cm-groupName' | translate: 'Group Name' }}"
                />
                <i p-input-icon-right class="bg-white">{{ groupName.value.length }}/255</i>
                <label for="groupName">{{ 'default-cm-groupName' | translate: 'Group Name' }}</label>
                @if (groupName && groupName.value.length > 255) {
                    <span class="text-red-500">
                        {{ 'default-character-exceed' | translate: 'Cannot exceed 255 characters' }}</span
                    >
                }
            </span>
            <span class="w-full p-float-label p-input-icon-right">
                <textarea
                    class="w-full"
                    id="groupDescription"
                    pInputTextarea
                    rows="1"
                    [autoResize]="true"
                    formControlName="groupDescription"
                    placeholder="{{ 'default-cm-description' | translate: 'Description' }}"
                ></textarea>
                <i p-input-icon-right class="bg-white">{{ groupDescription.value.length }}/255</i>
                <label for="groupDescription">{{ 'default-cm-description' | translate: 'Description' }}</label>
                @if (groupDescription && groupDescription.value.length > 255) {
                    <span class="text-red-500">
                        {{ 'default-character-exceed' | translate: 'Cannot exceed 255 characters' }}</span
                    >
                }
            </span>
        </div>
        <div class="flex gap-3 justify-content-between">
            <div class="w-full">
                <p-button
                    styleClass="w-full"
                    [outlined]="true"
                    label="{{ 'default-cm-cancel' | translate: 'Cancel' }}"
                    (onClick)="navigateToGroupTable()"
                ></p-button>
            </div>
            <div class="w-full">
                <p-button
                    styleClass="w-full"
                    [label]="
                        data
                            ? ('default-cm-update' | translate: 'Update')
                            : ('default-cm-addGroup' | translate: 'Add Group')
                    "
                    [disabled]="this.groupForm.invalid"
                    (onClick)="createNewGroup()"
                ></p-button>
            </div>
        </div>
    </div>
</div>
